import { render, staticRenderFns } from "./archive-in.vue?vue&type=template&id=5c8fc1a4&scoped=true"
import script from "./archive-in.vue?vue&type=script&lang=js"
export * from "./archive-in.vue?vue&type=script&lang=js"
import style0 from "./archive-in.vue?vue&type=style&index=0&id=5c8fc1a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8fc1a4",
  null
  
)

export default component.exports